import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import RtcRoom from "@/components/app/RtcRoom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Video, Loader2, VideoOff } from "lucide-react";
import { DUCK_LOGO } from "@/lib/api";

export default function PublicRoom() {
  const { id } = useParams();
  const [room, setRoom] = useState(null);
  const [state, setState] = useState("loading"); // loading | ready | error | joined
  const [errMsg, setErrMsg] = useState("");
  const [name, setName] = useState("");

  useEffect(() => {
    api.get(`/warroom/rooms/${id}`)
      .then(({ data }) => { setRoom(data); setState("ready"); })
      .catch((e) => {
        setErrMsg(e.response?.status === 410 ? "This room has ended." : "This room link is invalid or has expired.");
        setState("error");
      });
  }, [id]);

  if (state === "loading") {
    return <div className="min-h-screen grid place-items-center bg-slate-900 text-white"><Loader2 className="animate-spin" size={28} /></div>;
  }

  if (state === "error") {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-900 text-white px-6 text-center">
        <div>
          <VideoOff size={40} className="mx-auto text-slate-500 mb-3" />
          <p className="font-display text-xl font-black">{errMsg}</p>
          <p className="text-slate-400 text-sm mt-1">Ask your Credit Quack specialist for a fresh link.</p>
        </div>
      </div>
    );
  }

  if (state === "joined") {
    return (
      <div className="h-screen w-screen bg-black">
        <RtcRoom roomId={room.slug} displayName={name || "Client"} onLeave={() => setState("ready")} />
      </div>
    );
  }

  // ready → name prompt
  return (
    <div className="min-h-screen grid place-items-center bg-gradient-to-br from-slate-900 to-slate-800 text-white px-6">
      <div className="w-full max-w-sm text-center" data-testid="public-room-join">
        <img src={DUCK_LOGO} alt="Credit Quack" className="h-14 mx-auto mb-4" />
        <div className="h-12 w-12 rounded-xl bg-emerald-500 grid place-items-center mx-auto mb-3"><Video size={24} /></div>
        <h1 className="font-display text-2xl font-black">{room.title}</h1>
        <p className="text-slate-400 text-sm mt-1 mb-5">You're about to join a live video room with your Credit Quack team.</p>
        <Input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Your name"
          className="bg-white/10 border-white/20 text-white placeholder:text-slate-400 text-center"
          data-testid="public-room-name"
          onKeyDown={(e) => { if (e.key === "Enter" && name.trim()) setState("joined"); }}
        />
        <Button onClick={() => setState("joined")} disabled={!name.trim()} className="w-full mt-3 bg-emerald-600 hover:bg-emerald-700 font-black" data-testid="public-room-join-btn">
          <Video size={16} className="mr-1" /> Join the room
        </Button>
        <p className="text-[11px] text-slate-500 mt-4">Tip: on a computer you can share your screen to show your credit report. On iPhone you can show it with your camera.</p>
      </div>
    </div>
  );
}
